export const opacity = {
  default: 1,
  disabled: 0.5,
  "disabled-strong": 0.4,
  "loading-line": 0.56,
  "loading-surface": 0.72,
  overlay: 0.88,
  "pulse-low": 0.3,
  subdued: 0.6,
  pressed: 0.7000000000000001,
  "pressed-gentle": 0.88,
  "pressed-strong": 0.6,
  "pressed-subtle": 0.92,
} as const;

export type Opacity = typeof opacity;

export type OpacityToken = keyof Opacity;
